export default "__VITE_ASSET__CRD2q8Jv__"